import * as React from 'react';

import { Icon } from '@/shared/types/icon';

const Workvivo = ({ size = 24, ref, ...props }: Icon & { ref?: React.Ref<SVGSVGElement> }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="Layer_1"
      x={0}
      y={0}
      width={size}
      height={size}
      viewBox="0 0 200 200"
      {...props}
      ref={ref}
    >
      <style>{'.st1{fill:#fff}'}</style>
      <path d="M0 0h200v200H0z" style={{ fill: '#091f40' }} />
      <path
        d="m135.77 128.17-30.2-68.67c-1.59-3.61-4.51-6.4-8.21-7.84-1.76-.69-3.59-1.03-5.42-1.03-2.02 0-4.03.42-5.93 1.25-7.49 3.3-10.91 12.07-7.61 19.56l30.2 68.67c1.59 3.61 4.5 6.4 8.21 7.84 3.71 1.44 7.74 1.36 11.35-.23 7.49-3.29 10.9-12.06 7.61-19.55M121.75 61.96l16.7 37.97c1.79 4.08 6.57 5.93 10.65 4.14s5.94-6.57 4.15-10.65l-16.7-37.97a8.102 8.102 0 0 0-7.41-4.83c-1.09 0-2.19.22-3.24.68-4.08 1.8-5.94 6.58-4.15 10.66M89.51 139.91c1.44-3.71 1.36-7.74-.23-11.35l-15.17-34.5a14.71 14.71 0 0 0-8.21-7.83c-1.76-.69-3.59-1.03-5.42-1.03-2.02 0-4.03.42-5.93 1.25-3.61 1.59-6.4 4.51-7.84 8.21-1.44 3.71-1.36 7.74.23 11.35l15.17 34.5c1.59 3.61 4.51 6.39 8.21 7.84 3.71 1.44 7.74 1.36 11.35-.23 3.62-1.59 6.4-4.51 7.84-8.21M45.47 50.63c-8.16 0-14.81 6.64-14.81 14.81 0 8.16 6.64 14.81 14.81 14.81 8.17 0 14.81-6.64 14.81-14.81 0-8.17-6.64-14.81-14.81-14.81M161.17 50.63c-4.5 0-8.17 3.66-8.17 8.17 0 4.5 3.67 8.17 8.17 8.17s8.17-3.67 8.17-8.17c-.01-4.51-3.67-8.17-8.17-8.17"
        className="st1"
      />
    </svg>
  );
};

export default Workvivo;
